/**
 * Created by Jie Gao on 2017-05-11.
 */

import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class WixxSpinController extends SpinController {

    constructor() {
        super();
    }

    protected getSpinTime():number {
        if(this._mode === GameMode.RESPIN) {
            return 0.1;
        } else {
            return super.getSpinTime();
        }
    }
}